export const footballMoments = [
    {
        id: 1,
        img: '/images/Hobbies/hobbies-bsaks-letters.webp',
        title: 'Saka receiving fan letters',
        date: 'Aug 4, 2021',
        description: `After Euro 2020 heartbreak and online racism, Saka returned to Arsenal to overwhelming global fan support and encouragement.`,
        videoUrl: '/videos/sakaletters.mp4'
    },
    {
        id: 2,
        img: '/images/Hobbies/hobbies-declan-nice.webp',
        title: 'Declan rice freekick double',
        date: 'Apr 8, 2025',
        description: `Declan Rice delivered two sensational free kicks in the Champions League quarter-final, leading us to victory over defending champions Real Madrid.`,
        videoUrl: '/videos/declan.mp4'
    },
    {
        id: 3,
        img: '/images/Hobbies/hobbies-reiss-blamson.webp',
        title: "Reiss Nelson's Last Minute Goal",
        date: 'Mar 4, 2023',
        description: `Trailing by two while chasing the title, We mounted a dramatic comeback, sealed by Reiss Nelson’s match winning strike on the last kick of the game`,
        videoUrl: '/videos/reiss.mp4'
    }
]; 